<template>
	<div>
		<ul
			class="list-unstyled d-flex mb-2 flex-wrap justify-content-center"
			:class="$style.footerNav"
		>
			<li>
				<a href="#">Condiciones de uso</a>
			</li>
			<li>
				<a href="#">Política de privacidad</a>
			</li>
			<li>
				<a
					href="https://calltek.es/contacto"
					target="_blank"
				>Soporte</a>
			</li>
			<li>
				<a
					href="https://calltek.es/contacto"
					target="_blank"
				>Contacto</a>
			</li>
		</ul>
		<div class="text-white text-center">
			© 2020 GestiOS. Todos los derechos reservados.
		</div>
	</div>
</template>

<script>
export default {
	name: 'Terms'
};
</script>

<style lang="scss" module>
.footerNav {
	li {
		margin: rem(5) rem(14);
	}

	li>a{
		color: white !important;
	}
}

</style>
